import React__default from 'react';
import c from 'classnames';
import { useThemeVariable } from '@lyearn/style';

var Loader = function Loader(props) {
  var _props$arcColorToken = props.arcColorToken,
    arcColorToken = _props$arcColorToken === void 0 ? 'icon-active' : _props$arcColorToken,
    _props$circleColorTok = props.circleColorToken,
    circleColorToken = _props$circleColorTok === void 0 ? 'icon-placeholder' : _props$circleColorTok,
    className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    _props$thickness = props.thickness,
    thickness = _props$thickness === void 0 ? 3 : _props$thickness;
  var arcColor = useThemeVariable(arcColorToken);
  var circleColor = useThemeVariable(circleColorToken);
  return /*#__PURE__*/React__default.createElement("svg", {
    className: c(className, 'animate-spin'),
    fill: "none",
    height: size,
    viewBox: "0 0 24 24",
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M21.5 12.1C21.5 17.4148 17.2339 21.7 12 21.7C6.76606 21.7 2.5 17.4148 2.5 12.1C2.5 6.78529 6.76606 2.50005 12 2.50005C17.2339 2.50005 21.5 6.78529 21.5 12.1Z",
    stroke: circleColor,
    strokeWidth: thickness
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.5 12C21.5 6.4772 17.374 2.50005 11.9009 2.50005",
    stroke: arcColor,
    strokeLinecap: "round",
    strokeWidth: thickness
  }));
};
var Loader$1 = /*#__PURE__*/React__default.memo(Loader);

export { Loader$1 as default };
//# sourceMappingURL=Loader.js.map
